import { Component, Input, OnInit } from '@angular/core';
import { LandTitleDto } from '@cradua/data';

@Component({
  selector: 'cradua-measurement-conversion-table',
  templateUrl: './measurement-conversion-table.component.html',
  styleUrls: ['./measurement-conversion-table.component.scss']
})
export class MeasurementConversionTableComponent  {

@Input() selectedLandTitle: LandTitleDto;

}
